import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ButtonComponent } from 'src/app/shared/components/button/button.component';
import { HeadingComponent } from 'src/app/shared/components/heading/heading.component';

@Component({
  standalone: true,
  imports: [IonicModule, HeadingComponent, CommonModule, ButtonComponent],
  selector: 'mable-clean-slate',
  templateUrl: './clean-slate.component.html',
  styleUrls: ['./clean-slate.component.scss'],
})
export class CleanSlateComponent implements OnInit {
  @Input() cHeading: string;

  @Input() isHeading = true;

  @Input() cBody: string;

  @Input() cActionText: string;

  @Output() cAction = new EventEmitter<any>();

  @Input() cHeadingClasses: string;

  @Input() notFoundImage: string;

  @Input() category = '';

  @Input() contactUs = false;

  @Input() isImageOnTop = false;

  // A flag that determines whether or not the grid content is rendered at the top or in the middle (default)
  @Input() alignTop = false;

  public isActionCleanSlate: Readonly<boolean> = false;

  ngOnInit() {
    this.isActionCleanSlate = this.cAction.observers.length > 0;
    if (this.isActionCleanSlate) {
      if (!this.cHeading) {
        this.cHeading = 'No results found';
      }
      if (!this.cBody) {
        this.cBody = "We couldn't find exact matches for your search.";
      }
      if (!this.cActionText) {
        this.cActionText = 'Adjust search';
      }
    } else {
      if (!this.cHeading) {
        this.cHeading = 'Your tab is empty';
      }
      if (!this.cBody) {
        this.cBody = '';
      }
    }
  }

  emitEvent() {
    this.cAction.emit();
  }
}
